import { CompanyIntegrationStatus } from "@/components/integrations/company/company-integrations-sync";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";
import { CompanyCrmIntegration } from "@shaarp/common";
import { ExternalLink, RefreshCwIcon, SearchIcon } from "lucide-react";

export const SearchResults = ({
  integration,
  crmCompanies,
  onSyncToCompany,
  onOpenExternal,
}: {
  integration: CompanyIntegrationStatus;
  crmCompanies: CompanyCrmIntegration[];
  onSyncToCompany: (externalCompanyId: string) => void;
  onOpenExternal: (crmCompany: CompanyCrmIntegration) => void;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="px-3 py-2 border-t border-border/50">
        <div className="flex gap-3 items-center text-sm font-medium text-muted-foreground">
          <SearchIcon className="w-4 h-4" />
          {t("company.integrations.searchResults")}
        </div>
      </div>

      {crmCompanies.map((crmCompany) => (
        <div
          key={crmCompany.id}
          className="flex gap-4 items-center px-3 py-3 rounded-sm [&_svg]:size-4 [&_svg]:shrink-0"
        >
          <img
            src={integration.logo}
            alt={integration.name}
            className="object-contain shrink-0 w-6 h-6"
          />
          <div className="flex flex-col flex-1 gap-1">
            {crmCompany?.name && (
              <span className="text-sm font-medium">
                {crmCompany.name || "Unknown Company"}
              </span>
            )}
            <span className="text-xs text-muted-foreground">
              {crmCompany.domain}
            </span>
          </div>
          <div className="flex shrink-0 gap-2 items-center">
            <Button
              variant="ghost"
              size="sm"
              className="p-0 w-8 h-8 hover:bg-muted"
              disabled={!crmCompany.directLink}
              onClick={(e) => {
                e.stopPropagation();
                onOpenExternal(crmCompany);
              }}
              title={t("company.integrations.openInIntegration", {
                integration: integration.name,
              })}
            >
              <ExternalLink className="w-4 h-4" />
            </Button>
            <Button
              variant="ghost"
              size="sm"
              className="p-0 w-8 h-8 hover:bg-muted"
              disabled={integration.isLoading}
              onClick={(e) => {
                e.stopPropagation();
                onSyncToCompany(crmCompany.id);
              }}
              title={t("company.integrations.syncToIntegration", {
                integration: integration.name,
              })}
            >
              {/* Only the candidate being linked spins: the others are
                  merely held back until that send settles. */}
              <RefreshCwIcon
                className={`w-4 h-4 ${
                  integration.loadingMatchId === crmCompany.id
                    ? "animate-spin"
                    : ""
                }`}
              />
            </Button>
          </div>
        </div>
      ))}
    </>
  );
};
